import { Injectable } from '@angular/core';
import { of, Observable, catchError, throwError, tap } from 'rxjs';
import { Campaign } from '../models/campaign';
import { CampaignStatus } from '../enums/campaign-status';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class CampaignService {
  private readonly baseUrl = `${environment.apiUrl}/campaigns`;

  constructor(private http: HttpClient) {}

  getAllCampaigns(): Observable<Campaign[]> {
    return this.http.get<Campaign[]>(this.baseUrl);
  }

  getCampaignById(id: number): Observable<Campaign> {
    return this.http.get<Campaign>(`${this.baseUrl}/${id}`);
  }

  getActiveCampaign(): Observable<Campaign> {
    return this.http.get<Campaign>(`${this.baseUrl}/activeCompaign`);
  }

  createCampaign(campaign: Partial<Campaign>): Observable<Campaign> {
    return this.http.post<Campaign>(this.baseUrl, campaign);
  }

  updateCampaign(id: number, campaign: Partial<Campaign>): Observable<Campaign> {
    return this.http.put<Campaign>(`${this.baseUrl}/${id}`, campaign);
  }

  closeCampaign(id: number, closedBy: string , totalEmployees: number): Observable<Campaign> {
        const payload = {
      closedBy: closedBy,
      totalEmployees: totalEmployees
    };
    return this.http.put<Campaign>(`${this.baseUrl}/${id}`, payload);
  }

  sendReminders(campaignId: number, category?: string, chartImageBase64?: string, triggeredByEmail?: string, triggeredByName?: string) {
    const url = `${this.baseUrl}/${campaignId}/send-reminders${category ? `?category=${category}` : ''}`;
    const payload = { chartImage: chartImageBase64, triggeredByEmail: triggeredByEmail, triggeredByName: triggeredByName };
    return this.http.post<any>(url, payload);
  }

  triggerEvaluationBatch(): Observable<void> {
    return this.http.post<void>(
      `${this.baseUrl}/batch/trigger-evaluation-sync`,
      {}
    );
  }

}
